<template>
<div>
  <page-header :title="title"></page-header>
  <form @submit.prevent="gravar">
    <div class="modal-body">
      <div class="form-horizontal">
        <vue-element-loading :active="isActive" spinner="bar-fade-scale" color="#428BCA"></vue-element-loading>
        <input-form-text textInput="Título" :required="true" v-model="form.titulo" :value="form.titulo"></input-form-text>
		<div class="form-group">
			<label class="col-sm-3 control-label no-padding-right"></label>
			<div class="col-sm-5">
				<file-upload v-if="!allFiles.length" ref="fupload" :url="'/v1/fornecedores/upload'" :id="null"
					:label="'PDF até 10 MB'" :multiple="false" texto="Enviar Arquivos" accept=".pdf" :isFile="true"></file-upload>
				<items-edit v-else :files="allFiles"
					url="/v1/fornecedores/upload" id="id" :isFile="true"></items-edit>
			</div>
		</div>
        <div class="form-group">
          <select-form v-model="form.ativo" :value="form.ativo" name="Ativo" url="/arquivos" id="id" titulo="nome" layout="true" optionText="Selecione" required="true"></select-form>
        </div>
      </div>
    </div>
    <footer-button :disabled="isActiveBtn"></footer-button>
  </form>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'
import fileUpload from '@/components/form/file-upload/Index'
import ItemsEdit from '@/components/form/file-upload/ItemsEdit'

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading,
		fileUpload,
		ItemsEdit
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Fornecedores',
			form: {
				titulo: '',
				ativo: '1'
			},
			allFiles: [],
			isActiveBtn: false,
			isActive: false,
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		async gravar() {
			this.isActive = true
			this.isActiveBtn = true
			const body = this.form
			//this.setVersion()
			if (this.$route.params.id) {
				const resp = await req(`/v1/fornecedores/${this.$route.params.id}`, 'put', body).catch(response => {
					'error: ' + response
					erro()
				})
				if (!this.allFiles.length) {
					this.isActive = false
					const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
					const m = tb[0]
					await m.uploadAll(resp)
				}
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/servicos/fornecedores')
			} else {
				const resp = await req('/v1/fornecedores', 'post', body).catch(response => {
					'error: ' + response
					erro()
				})
				this.isActive = false
				const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
				const m = tb[0]
				await m.uploadAll(resp)
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/servicos/fornecedores')
			}
			this.isActive = false
		},
		async setVersion() {
			const dados = await req('/versao/1', 'put', {
				title: Date.now()
			})
			dados
		},
		async getDados() {
			const resp = await req(`/v1/fornecedores/${this.$route.params.id}`).catch(response => {
				'error: ' + response
				erro()
			})
			this.form.ativo = resp.ativo
			this.form.titulo = resp.titulo
			this.allFiles = resp.arquivo ? [{ id: this.$route.params.id, files: resp.arquivo }] : ''
			this.isActive = false
		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		}
	},
	mounted() {
		this.verifPermissao()
		if (this.$route.params.id) {
			this.isActive = true
			this.getDados()
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
